var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"hide-details":"","items":_vm.queryNum.Order,"label":"تعداد موارد"},model:{value:(_vm.model.numRows),callback:function ($$v) {_vm.$set(_vm.model, "numRows", $$v)},expression:"model.numRows"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }